import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { BASE_URL, AUTH, AUTHH } from '../../../config/axios';
import { AddwithWhiteCircle, Attachment, UpdatePencil } from '../../AllSvg';
import { Modal } from 'react-bootstrap';
import { toast } from "react-toastify";



const AddSubcompany = ({ getSubcompany }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setFormData({
            company_name: "",
            company_address: "",
            company_number: "",
            company_gst: "",
            company_logo: "null",
        });
        setShow(false);
        setErrors({})
    };
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        company_name: "",
        company_address: "",
        company_number: "",
        company_gst: "",
        company_logo: "null",
    });

    // !  ************** Validation start **************  ! //
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["company_name", "company_gst", `company_address`, `company_address`];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        // console.log(newErrors)
        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic
    const [uploadProgress, setUploadProgress] = useState(0);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            const formDataa = new FormData();
            formDataa.append("company_name", formData.company_name);
            formDataa.append("company_address", formData.company_address);
            formDataa.append("company_number", formData.company_number);
            formDataa.append("company_gst", formData.company_gst);

            const symbols = "!@#$%^&*()_-+=";
            const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
            const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            const numbers = "0123456789";
            const now = new Date();
            const date = now
                .toLocaleDateString("en-GB")
                .split("/")
                .reverse()
                .join("-"); // Format: YYYY-MM-DD
            const time = now
                .toLocaleTimeString("en-GB", { hour12: false })
                .replace(/:/g, "-"); // Format: HH-MM-SS
            const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
            let randomCode = "";
            for (let i = 0; i < 8; i++) {
                const randomIndex = Math.floor(Math.random() * allChars.length);
                randomCode += allChars[randomIndex];
            }
            const originalFile = formData.company_logo;
            const customFileName = `Aimantra ${date} ${time}_${randomCode} ${originalFile.name}`;
            const customFile = new File([originalFile], customFileName, {
                type: originalFile.type,
            });
            formDataa.append("company_logo", customFile);

            try {
                let res = await axios.post(
                    `${BASE_URL}/dpr/subcompany/`,
                    formDataa,
                    {
                        ...AUTHH,
                        onUploadProgress: (progressEvent) => {
                            const percentCompleted = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            setUploadProgress(percentCompleted);
                        },
                    },
                );

                if (res.status === 200 || res.status === 201) {
                    await getSubcompany();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("Data added successfully!");
                } else {
                    toast.dismiss(loadingToastId);
                    toast.error("Failed to add Data!");
                }
            } catch (err) {
                //toast Logic
                console.error(err);

            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            if (value.trim()) {
                delete updatedErrors[name];
            }
            return updatedErrors;
        });
    };

    const handleFileChange = (e) => {
        const { name, value } = e.target;
        const file = e.target.files[0];

        if (file) {
            const validFileTypes = ["image/png"]; // ✅ Only PNG allowed

            if (validFileTypes.includes(file.type)) {
                setFormData({
                    ...formData,
                    [name]: file,
                });
                setErrors({
                    ...errors,
                    [name]: "", // Clear previous error
                });
            } else {
                setErrors({
                    ...errors,
                    [name]: "Invalid file type. Please select a PNG image only.",
                });
            }
        }
        else {
            setFormData({
                ...formData,
                [name]: null,
            });
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            if (value.trim()) {
                delete updatedErrors[name];
            }
            return updatedErrors;
        });

    };

    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });
    };

    return (
        <>
            <button title="Add Company" className="upload-svg" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <g clipPath="url(#clip0_1415_3177)">
                        <path
                            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
                            fill="white"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_1415_3177">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                {" "}Company
            </button>


            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                {/* <Modal.Header closeButton>
          <Modal.Title>Request Leave</Modal.Title>
        </Modal.Header> */}
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500    font-size-heading "
                >
                    <Modal.Title> Add Company Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            {/* <h6 className="task-Tab-heading font-weight500    font-size-heading">Circular</h6> */}

                            <form>
                                <div className="flex-column">
                                    <label
                                        htmlFor="company_name"
                                        className="form-labels font-weight500    announce-date font-weight400  font-size-heading" title="Company Name"
                                    >
                                        Company Name<span className="required">*</span>
                                    </label>
                                    <input
                                        id="company_name"
                                        title="company_name"
                                        type="text"
                                        name="company_name"
                                        placeholder="Company Name"
                                        onChange={handleInputChange}
                                        value={formData.company_name}
                                        className={`form-input ${errors.company_name ? "error" : inputState.company_name ? "success" : ""
                                            }`}
                                    />
                                    {errors.company_name && (
                                        <span className="error-message font-size-text ">
                                            {errors.company_name}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="company_address"
                                        className="form-labels font-weight500    announce-date font-weight400  font-size-heading" title="Company Address"
                                    >
                                        Company Address<span className="required">*</span>
                                    </label>
                                    <textarea
                                        id="company_address"
                                        title="company_address"
                                        type="text"
                                        name="company_address"
                                        placeholder="company_address"
                                        onChange={handleInputChange}
                                        value={formData.company_address}
                                        className={`form-input-textarea ${errors.company_address ? "error" : inputState.company_address ? "success" : ""
                                            }`}
                                    />
                                    {errors.company_address && (
                                        <span className="error-message font-size-text ">
                                            {errors.company_address}
                                        </span>
                                    )}
                                </div>
                                <div className="flex-column">
                                    <label
                                        htmlFor="company_number"
                                        className="form-labels font-weight500    announce-date font-weight400  font-size-heading" title="Company Mobile Number"
                                    >
                                        Company Mobile Number<span className="required">*</span>
                                    </label>
                                    <input
                                        id="company_number"
                                        title="company_number"
                                        type="number"
                                        name="company_number"
                                        min={0}
                                        placeholder="Company Mobile Number"
                                        onChange={handleInputChange}
                                        value={formData.company_number}
                                        className={`form-input ${errors.company_number ? "error" : inputState.company_number ? "success" : ""
                                            }`}
                                    />
                                    {errors.company_number && (
                                        <span className="error-message font-size-text ">
                                            {errors.company_number}
                                        </span>
                                    )}
                                </div>
                                <div className="flex-column">
                                    <label
                                        htmlFor="company_gst"
                                        className="form-labels font-weight500    announce-date font-weight400  font-size-heading" title="Company GST Number"
                                    >
                                        Company GST Number<span className="required">*</span>
                                    </label>
                                    <input
                                        id="company_gst"
                                        title="company_gst"
                                        type="text"
                                        name="company_gst"
                                        min={0}
                                        placeholder="Company GST Number"
                                        onChange={handleInputChange}
                                        value={formData.company_gst}
                                        className={`form-input ${errors.company_gst ? "error" : inputState.company_gst ? "success" : ""
                                            }`}
                                    />
                                    {errors.company_gst && (
                                        <span className="error-message font-size-text ">
                                            {errors.company_gst}
                                        </span>
                                    )}
                                </div>




                                <div className="flex-column ">
                                    <label className="form-labels font-weight500    announce-date font-weight400  font-size-heading">Company Logo
                                        <span className="required">*</span>
                                    </label>
                                    <div className={`file-upload-container flex-row justify-between file-in-upload ${errors.company_logo ? 'error' : inputState.company_logo ? 'success' : ''}`}>
                                        <label style={{ cursor: 'pointer' }} htmlFor="company_logo">
                                            <Attachment />

                                            <span className="form-text-trasformation-uppercase" style={{ marginLeft: "20px" }}>
                                                {formData.company_logo ? formData.company_logo.name : 'No file selected'}
                                            </span>
                                        </label>
                                        <input
                                            id="company_logo"
                                            name="company_logo"
                                            type="file"
                                            accept=".png"
                                            onChange={handleFileChange}
                                            style={{ display: "none", position: "relative" }}
                                        />
                                        {formData.company_logo ? (<span className="file-clear" onClick={() => handleFileClear('company_logo')}>
                                            Clear
                                        </span>) : null}
                                    </div>

                                </div>

                                {/* <div className="flex-column">
                  <label
                    htmlFor="file"
                    className="form-labels font-weight500    announce-date font-weight400  font-size-heading" title="Attachement"
                  >
                    Attachment<span className="required">*</span>
                  </label>
                  <label
                    htmlFor={`file`}
                    className={`form-inputss custom-file-upload ${errors.file
                      ? "error" :
                      ""
                      }`}
                  >
                    <div className={`align-center pdf-input  ${errors.file ? 'error' : ''}`}>
                    </div>
                  </label>
                  <input
                    id="file"
                    type="file"
                    title="Attachment"
                    name="file"
                    accept=".pdf, .doc, .docx, .xls, .xlsx"
                    style={{ display: "none", position: "relative" }}
                    onChange={handleFileChange}
                    className="file-input"
                  />
                  <br />
                  <div>
                    {errors.file && (
                      <span className="error-message font-size-text circular-file-error">
                        {errors.file}
                      </span>
                    )}
                  </div>
                  <div>
                    {formData.file ? (
                      <span
                        className="file-clear"
                        onClick={() => handleFileClear("file")}
                      >
                        Clear
                      </span>
                    ) : null}
                  </div>
                </div> */}

                            </form>
                            {uploadProgress > 0 && (
                                <div className="progress-bar">
                                    <h6 className="uploading-percentage">Uploading {uploadProgress}%</h6>
                                    <div className="progress-bar-fill" style={{ width: `${uploadProgress}%` }}></div>

                                </div>
                            )}
                            <div className="button-models">
                                <button
                                    className="model-button font-weight500 model-button-cancel"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                            <p className="error-message font-size-text">
                                {isSubmitted && Object.keys(errors).length > 0 && (
                                    Object.keys(errors).length > 5 ? (
                                        <h5 className="text-center">Please fill all mandatory fields!</h5>
                                    ) : (

                                        <h6 className="text-center">
                                            {Object.keys(errors).map((field) =>
                                                field.charAt(0).toUpperCase() + field.slice(1)
                                            ).join(', ') + ' are required!'}
                                        </h6>
                                    )
                                )}
                            </p>
                        </div>
                    </div>
                    
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateSubCompany = ({ i, getSubcompany }) => {
    const [show, setShow] = useState(false);
    const [inputState, setInputState] = useState({});
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        const filteredData = { ...i };
        delete filteredData.company_logo;
        setFormData(filteredData);


    };

    const [formData, setFormData] = useState({
        company_name: "",
        company_address: "",
        company_number: "",
        company_gst: "",
        company_logo: "null",
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const [loading, setLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["company_name", "company_gst", `company_address`, `company_address`];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        // console.log(newErrors)
        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };


    const [docNames, setDocNames] = useState();

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            const symbols = "!@#$%^&*()_-+=";
            const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
            const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            const numbers = "0123456789";
            const now = new Date();
            const date = now
                .toLocaleDateString("en-GB")
                .split("/")
                .reverse()
                .join("-"); // Format: YYYY-MM-DD
            const time = now
                .toLocaleTimeString("en-GB", { hour12: false })
                .replace(/:/g, "-"); // Format: HH-MM-SS
            const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
            let randomCode = "";
            for (let i = 0; i < 8; i++) {
                const randomIndex = Math.floor(Math.random() * allChars.length);
                randomCode += allChars[randomIndex];
            }
            const customFileName = `Aimantra ${date} ${time}_${randomCode} ${file.name}`;
            const customFile = new File([file], customFileName, { type: file.type });

            setFormData({
                ...formData,
                company_logo: customFile,
            });
            setDocNames(customFileName);
        } else {
            setDocNames("");
        }
    };

    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            company_logo: null,
        });
        setDocNames("");
    };


    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const updatedfromdata = {
            ...formData,
        };
        if (validateForm()) {
            setLoading(true);
            const loadingToastId = toast.loading("Loading: Please wait...");
            const formDataToSend = new FormData();

            Object.keys(updatedfromdata).forEach((key) => {
                if (updatedfromdata[key] && key !== "company_logo") {
                    formDataToSend.append(key, updatedfromdata[key]);
                }
            });

            if (updatedfromdata.company_logo) {
                formDataToSend.append("company_logo", updatedfromdata.company_logo);
            }

            try {
                const res = await axios.put(
                    `${BASE_URL}/dpr/subcompany/${i.id}/`,
                    formDataToSend,
                    AUTHH()
                );

                if (res.status === 200) {

                    await getSubcompany();
                    toast.dismiss(loadingToastId);
                    toast.success("Data Updated successfully!");
                    setShow(false);
                } else {
                    toast.dismiss(loadingToastId);
                    toast.error("Failed to Update Data!");
                }
            } catch (err) {
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <button
                title="Update Data"
                className="model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500    font-size-heading "
                >
                    <Modal.Title> Update Company Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="parent-div">
                        <div className="bdy-div">
                            <form onSubmit={handleFormSubmit}>
                                <div className="flex-column">
                                    <label
                                        htmlFor="company_name"
                                        className="form-labels font-weight500    announce-date font-weight400  font-size-heading" title="Company Name"
                                    >
                                        Company Name<span className="required">*</span>
                                    </label>
                                    <input
                                        id="company_name"
                                        title="company_name"
                                        type="text"
                                        name="company_name"
                                        placeholder="Company Name"
                                        onChange={handleInputChange}
                                        value={formData.company_name}
                                        className={`form-input ${errors.company_name ? "error" : inputState.company_name ? "success" : ""
                                            }`}
                                    />
                                    {errors.company_name && (
                                        <span className="error-message font-size-text ">
                                            {errors.company_name}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="company_address"
                                        className="form-labels font-weight500    announce-date font-weight400  font-size-heading" title="Company Address"
                                    >
                                        Company Address<span className="required">*</span>
                                    </label>
                                    <textarea
                                        id="company_address"
                                        title="company_address"
                                        type="text"
                                        name="company_address"
                                        placeholder="company_address"
                                        onChange={handleInputChange}
                                        value={formData.company_address}
                                        className={`form-input-textarea ${errors.company_address ? "error" : inputState.company_address ? "success" : ""
                                            }`}
                                    />
                                    {errors.company_address && (
                                        <span className="error-message font-size-text ">
                                            {errors.company_address}
                                        </span>
                                    )}
                                </div>
                                <div className="flex-column">
                                    <label
                                        htmlFor="company_number"
                                        className="form-labels font-weight500    announce-date font-weight400  font-size-heading" title="Company Mobile Number"
                                    >
                                        Company Mobile Number<span className="required">*</span>
                                    </label>
                                    <input
                                        id="company_number"
                                        title="company_number"
                                        type="number"
                                        name="company_number"
                                        min={0}
                                        placeholder="Company Mobile Number"
                                        onChange={handleInputChange}
                                        value={formData.company_number}
                                        className={`form-input ${errors.company_number ? "error" : inputState.company_number ? "success" : ""
                                            }`}
                                    />
                                    {errors.company_number && (
                                        <span className="error-message font-size-text ">
                                            {errors.company_number}
                                        </span>
                                    )}
                                </div>
                                <div className="flex-column">
                                    <label
                                        htmlFor="company_gst"
                                        className="form-labels font-weight500    announce-date font-weight400  font-size-heading" title="Company GST Number"
                                    >
                                        Company GST Number<span className="required">*</span>
                                    </label>
                                    <input
                                        id="company_gst"
                                        title="company_gst"
                                        type="text"
                                        name="company_gst"
                                        min={0}
                                        placeholder="Company GST Number"
                                        onChange={handleInputChange}
                                        value={formData.company_gst}
                                        className={`form-input ${errors.company_gst ? "error" : inputState.company_gst ? "success" : ""
                                            }`}
                                    />
                                    {errors.company_gst && (
                                        <span className="error-message font-size-text ">
                                            {errors.company_gst}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels  font-weight500 font-size-subheading">Company Logo</label>
                                    <div className="flex-row">

                                        <label htmlFor={`company_logo`} className={` custom-file-upload ${errors[`company_logo`] ? "error" : inputState[`company_logo`] ? "success" : ""}`}>
                                            <svg className="pdf-input" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20" fill="none">
                                                <path d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831" stroke="#707070" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </label>
                                        <input
                                            id="company_logo"
                                            name="company_logo"
                                            type="file"
                                            accept='.png'
                                            onChange={handleFileChange}
                                            style={{ display: "none", position: "relative" }}
                                        />
                                        {docNames && <p className="file-name align-center">{docNames}</p>}
                                        {formData.company_logo ? (
                                            <span
                                                className="file-clear model-button-cancel"
                                                onClick={() => handleFileClear("file")}
                                            >
                                                Clear
                                            </span>
                                        ) : null}
                                        {errors.company_logo && <div className="error-message font-size-text">{errors.company_logo}</div>}
                                    </div>
                                </div>
                                <div className="button-models">
                                    <button
                                        className="model-button font-weight500 model-button-leave font-size-heading"
                                        type="submit"
                                        onClick={handleFormSubmit}
                                        disabled={loading}
                                    >
                                        {loading ? "Updating..." : "Update"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteSubCompany = ({ i, getSubcompany }) => {
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true)
    }

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(
                `${BASE_URL}/dpr/subcompany/${i.id}/`,
                AUTH
            );

            if (res.status === 200 || res.status === 204) { 
                toast.success(`${i.division_name} deleted successfully`);
                await getSubcompany(); // refresh table
                setShow(false);
            }
        } catch (err) {
            toast.error("Failed to delete division");
            console.error(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Insurance"
                className="model-delete-button"
                onClick={handleShow}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal
                show={show}
                onHide={() => setShow(false)}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Delete Company: {i.company_name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Are you sure you want to delete{" "}
                        <strong>{i.company_name}</strong>?
                    </p>
                    <div className="button-models">
                        <button
                            className="model-button model-button-cancel"
                            onClick={() => setShow(false)}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};



export { AddSubcompany, UpdateSubCompany, DeleteSubCompany }